import React, { useEffect, useState } from "react";

// Material UI
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { styled } from "@mui/material/styles";

// Components
import GraficoTeia from "./Resultado/GraficoTeia";
import Criticidade from "./Resultado/Criticidade";

// React Router
import { useParams } from "react-router-dom";

// Redux
import { useSelector } from "react-redux";
import { selectToken } from "../storeConfig/reducers/loginReducer";

// Axious
import { useResultByID } from "../services/resultado";

import {
	calcularGI,
	calcularGrauDeInovacaoGeral,
	classificarOrganizacao,
	grauDeInovaçãoDeCadaDimensão,
} from "../assets/utils/calcularGrauInovação";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	padding: theme.spacing(2),
	textAlign: "center",
}));

const ResultadoList = () => {
	const [grauGeral, setGrauGeral] = useState("");
	const [grauPorDimensão, setGrauPorDimensão] = useState("");
	const [classificação, setClassificação] = useState("");
	const [data_resultado, setDataResultado] = useState("");

	const token = useSelector(selectToken);
	const params = useParams();

	// React Query
	const { data: resultado } = useResultByID(token, params.id);
  
	// Calcular Grau de Inovação Geral
	const main = (
		resultado,
		callbackGrauDeInovacaoGeral,
		callbackCalcularGI,
		callbackClassificação,
		callbackPorDimensao
	) => {
		const { EMI, GGPI, AIO, IGC, PG } = resultado;

		const emi = callbackCalcularGI(EMI);
		const ggpi = callbackCalcularGI(GGPI);
		const aio = callbackCalcularGI(AIO);
		const igc = callbackCalcularGI(IGC);
		const pg = callbackCalcularGI(PG);

		let grauDeInovaçãoGeral = callbackGrauDeInovacaoGeral(
			EMI,
			GGPI,
			AIO,
			IGC,
			PG
		);
		let classificação = callbackClassificação(grauDeInovaçãoGeral.float);
		let porDimensão = callbackPorDimensao(emi, ggpi, aio, igc, pg);

		setGrauGeral(grauDeInovaçãoGeral.string);
		setClassificação(classificação);
		setGrauPorDimensão(porDimensão);
	};

	useEffect(() => {
		if (resultado) {
			main(
				resultado.resultado,
				calcularGrauDeInovacaoGeral,
				calcularGI,
				classificarOrganizacao,
				grauDeInovaçãoDeCadaDimensão
			);
			setDataResultado(resultado.data_resultado);
		}
	}, [resultado]);

	return (
		<>
			{grauGeral &&
			grauPorDimensão &&
			classificação &&
			data_resultado &&
			resultado ? (
				<Container className="mt-5">
					<div className="row d-flex justify-content-around">
						<Button
							className="col-sm-4"
							id="exportar"
							onClick={() => window.print()}
							endIcon={<PictureAsPdfIcon />}
						>
							Exportar como PDF
						</Button>
					</div>

					<section className="mb-5">

						<h1 className="mt-5">{resultado.nome_organizacao}</h1>
						<div className="d-flex justify-content-center mb-5">
							{new Date(data_resultado).toLocaleDateString(
								"pt-BR"
							)}
						</div>

						<h2>Grau de Inovação Geral</h2>
						<hr />
						<h1 className="mt-5">{grauGeral}</h1>
						<h2>{classificação}</h2>
						<div className=" mt-5 text-center">
							<Grid
								container
								columnSpacing={{ xs: 1, sm: 2, md: 3 }}
								className="d-flex justify-content-center"
							>
								<Grid item xs={5} md={2}>
									<p>
										{" "}
										<b> = 1</b>
										<br />
										Não Inovadora
									</p>
								</Grid>
								<Grid item xs={5} md={2}>
									<p>
										{" "}
										<b> 1 &lt; GI &lt; 3</b>
										<br />
										Pouco Inovadora
									</p>
								</Grid>
								<Grid item xs={5} md={2}>
									<p>
										{" "}
										<b> 3 &le; GI &lt; 4 </b>
										<br />
										Inovadora Ocasional
									</p>
								</Grid>
								<Grid item xs={5} md={2}>
									<p>
										{" "}
										<b> &ge; 4 </b>
										<br />
										Inovadora Sistêmica
									</p>
								</Grid>
							</Grid>
						</div>
					</section>

					<section className="mb-5">
						<h2>Grau de Inovação por Dimensão</h2>
						<hr />
						<GraficoTeia data={grauPorDimensão} />

						<Box className="mb-5" sx={{ flexGrow: 1 }}>
							<Grid
								container
								rowSpacing={1}
								columnSpacing={{ xs: 1, sm: 2, md: 3 }}
								justifyContent="center"
								alignItems="flex-start"
							>
								<Grid item xs>
									<Item>
										<p>
											{" "}
											Estratégias Metodológicas para
											Inovação
										</p>
										<hr />
										<p>
											{grauPorDimensão[0].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Geração e Gestão da Propriedade
											Intelectual
										</p>
										<hr />
										<p>
											{grauPorDimensão[1].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>Ações de Inovação Organizacional</p>
										<hr />
										<p>
											{grauPorDimensão[2].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Investimento para Geração de
											Conhecimento
										</p>
										<hr />
										<p>
											{grauPorDimensão[3].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
								<Grid item xs>
									<Item>
										<p>
											Perfil do Gestor
											<br />
										</p>
										<hr />
										<p>
											{grauPorDimensão[4].value
												.toString()
												.replace(".", ",")}
										</p>
									</Item>
								</Grid>
							</Grid>
						</Box>
					</section>

					<section className="mb-5">
						<Criticidade
							EMI={resultado.resultado.EMI}
							GGPI={resultado.resultado.GGPI}
							AIO={resultado.resultado.AIO}
							IGC={resultado.resultado.IGC}
							PG={resultado.resultado.PG}
						/>
					</section>
				</Container>
			) : (
				<div className="d-flex justify-content-center mt-5">
					<CircularProgress />
				</div>
			)}
		</>
	);
};

export default ResultadoList;
